import { GridSlotsComponentsProps } from '@mui/x-data-grid-pro';

import { Centered } from 'components/grid';

declare module '@mui/x-data-grid-pro' {
    interface NoRowsOverlayPropsOverrides {
        started: boolean;
    }
}

export function CustomNoRowsOverlay({ started }: NonNullable<GridSlotsComponentsProps['noRowsOverlay']>) {
    return <Centered>{started ? 'Sem registros para exibir' : 'Utilize o filtro para visualizar os dados'}</Centered>;
}
